import { validateDate, validateDateAfter } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { giftService } from '@/services/gift';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export default function () {
    const crudAction = useCrudActions();

    const model = reactive({
        isNew: true,
        amount: 0,
        receiveLimit: 0,
        gamePercent: 0,
        slotPercent: 0,
        questPercent: 0,
        timeUnit: 0,
        timeDuration: 0,
        startTime: new Date(),
        endTime: new Date()
    });

    const validations = {
        amount: { required, numeric, minValue: minValue(1) },
        receiveLimit: { required, numeric, minValue: minValue(1) },
        gamePercent: { required, numeric, minValue: minValue(0), maxValue: maxValue(100) },
        slotPercent: { required, numeric, minValue: minValue(0), maxValue: maxValue(100) },
        questPercent: { required, numeric, minValue: minValue(0), maxValue: maxValue(100) },
        timeUnit: { required, numeric, minValue: minValue(0) },
        timeDuration: { required, numeric, minValue: minValue(1) },
        startTime: { validateDate: validateDate() },
        endTime: { validateDate: validateDate(), validateDateAfter: validateDateAfter('startTime') }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: giftService().lucky.get,
        onSuccess: ({ data }) => {
            model.isNew = false;
            model.amount = data.amount;
            model.receiveLimit = data.receiveLimit;
            model.gamePercent = data.gamePercent;
            model.slotPercent = data.slotPercent;
            model.questPercent = data.questPercent;
            model.timeDuration = data.timeDuration;
            model.timeUnit = data.timeUnit;
            model.startTime = new Date(data.startTime);
            model.endTime = new Date(data.endTime);
        },
        onError: () => {
            model.isNew = false;
            model.amount = 0;
            model.receiveLimit = 0;
            model.gamePercent = 0;
            model.slotPercent = 0;
            model.questPercent = 0;
            model.timeUnit = 0;
            model.timeDuration = 0;
            model.startTime = new Date();
            model.endTime = new Date();
        }
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                giftService().lucky.update(
                    model.amount,
                    model.receiveLimit,
                    model.gamePercent,
                    model.slotPercent,
                    model.questPercent,
                    model.timeUnit,
                    model.timeDuration,
                    model.startTime.getTime(),
                    model.endTime.getTime()
                ),
            onSuccess: fetch
        }),

        remove: crudAction.confirmAndRemove({
            request: giftService().lucky.remove,
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions };
}
